import React, { useState } from 'react';
import { Input } from '../../../../components/Input';
import { FilledButton } from '../../../../components/Buttons';

interface SignUpConfirmationFormProps {
  submissionError: unknown;
  onSubmit: (formData: SignUpConfirmationCodeDTO) => Promise<void>;
}

export interface SignUpConfirmationCodeDTO {
  code: string;
}

export function SignUpConfirmationForm(props: SignUpConfirmationFormProps) {
  const [isDuringSubmission, setIsDuringSubmission] = useState<boolean>(false);
  const [userFormFields, setUserFormFields] = useState<SignUpConfirmationCodeDTO>({
    code: ''
  });

  function handleChange(name: string, value: string) {
    setUserFormFields({ ...userFormFields, [name]: value });
  }

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setIsDuringSubmission(true);

    props.onSubmit(userFormFields).finally(() => {
      setIsDuringSubmission(false);
    });
  }

  return (
    <form
      className="w-full"
      id="smsCodeForm"
      onSubmit={handleSubmit}>
      <Input
        autoComplete="current-password"
        id="code"
        type="code"
        label="Enter Code"
        value={userFormFields.code}
        onChange={(event) => {
          handleChange('code', event.target.value);
        }}
        required={true}></Input>

      <div className="flex min-h-8 w-full">
        <span className={props.submissionError ? 'visible mx-auto self-center text-center text-red-500' : 'invisible'}>
          {props.submissionError as string}
        </span>
      </div>

      <div className="mx-auto w-3/6 pt-2">
        <FilledButton
          disabled={isDuringSubmission}
          type="submit">
          Submit
        </FilledButton>
      </div>
    </form>
  );
}
